import Headroom from "headroom.js";
// import WOW from "wow.js";
import 'owl.carousel';
// import 'jquery-match-height';
//import 'jquery-parallax.js';
//import AOS from 'aos/dist/aos.js';
//import Rellax from "rellax";
import 'lity';
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

export default {
  init() {
    /** JavaScript to be fired on all pages **/
    /* eslint-disable no-unused-vars */
    require('es6-object-assign').polyfill();

    $(document).on('lity:ready', function(event, instance) {
      $('div.lity-container iframe').load(function(){
        var video = $('div.lity-container iframe').contents().find('video');
        video.removeAttr('controls')
        video.prop('muted', true);
      });
    });


    const site_header = document.querySelector("header.main-site-header");
    const headroom    = new Headroom( site_header, {
      offset: 280,
      tolerance : {
          up : 5,
          down : 0,
      },
    });
    headroom.init();

    $(document).on('click', '.cameo-slider .slider-item a', function (e) {
      e.preventDefault();
    });

    $(document).on(
      "click",
      "header.main-site-header .navbar-toggler",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("html").toggleClass("mm-menu-open");
        $("header.main-site-header .navbar-toggler-icon").toggleClass("active");

        //window.scrollTo(0, 1);
      }
    );

    $('#read-more').click(function() {
      $(this).text(function(i,old) {
        return old.trim() === '+ Read more' ? '- Read less' : '+ Read more';
      });
    });

    $(document).on(
      "click",
      "header.main-site-header li.contact-link",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("contact-open");
      }
    );

    $(document).on(
      "click",
      "#contact-trigger",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("contact-open");
      }
    );

    $(document).on(
      "click",
      "#close-button",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("contact-open");
      }
    );

    //Countdown function
    function c(){
      var n = $('.c').attr('id');
      var c = n;
      $('.c').text(c);
      setInterval(function(){
        c--;
        if(c>=0){
          $('.c').text(c);
        }
            if(c==0){
                $('.c').text(n);
            }
      },1000);
    }

    //CF7 Submit Thank You Message
    document.addEventListener( 'wpcf7submit', function(  ) {
      //alert( "Fire!" );
      $('.wpcf7').hide();
      $('.form-header').hide();
      $('.success-text').show();
      c();
      setTimeout(function(  ) {
          location = 'https://goodhumans.local/';
      }, 6500 );
    }, false );

    $('a[href^="#"]').on('click',function (e) {
      e.preventDefault();

      var target = this.hash,
      $target = $(target);

      $('html, body').stop().animate({
          'scrollTop': $target.offset().top,
      }, 400, 'swing', function () {
          window.location.hash = target;
      });
    });

    $('a[href^="/#"]').on('click',function () {

      var target = this.hash,
      $target = $(target);

      $('html, body').stop().animate({
          'scrollTop': $target.offset().top,
      }, 400, 'swing', function () {
          window.location.hash = target;
      });
    });

    const swiper = new Swiper('.cameo-slider', {
      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      speed: 3500,
      grabCursor: false,
      allowTouchMove: false,
      mousewheelControl: false,
      keyboardControl: false,
      modules: [Autoplay, Navigation, Pagination],
    });

    const firstLogoCarousel = new Swiper('.first-logo-carousel', {
      freeMode: true,
      freeModeMomentum: false,
      freeModeMomentumBounce: false,

      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      speed: 3500,
      grabCursor: false,
      allowTouchMove: false,
      mousewheelControl: true,
      keyboardControl: true,
      modules: [Autoplay, Navigation, Pagination],
    });


    const secondLogoCarousel = new Swiper('.second-logo-carousel', {
      freeMode: true,
      freeModeMomentum: false,
      freeModeMomentumBounce: false,

      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      slidesPerView: 'auto',
      speed: 3500,
      grabCursor: false,
      allowTouchMove: false,
      mousewheelControl: true,
      keyboardControl: true,
      modules: [Autoplay, Navigation, Pagination],
    });

    if ($(".main-testimonial-carousel").length > 0) {
      $(".main-testimonial-carousel.owl-carousel").owlCarousel({
        items: 1,
        dots: true,
        nav: false,
        margin: 30,
        responsive: {
          768: {
            items: 1,
          },
          992: {
            items: 1,
          },
          1200: {
            items: 1,
          },
        },
      });
    }

    var doc = document.documentElement;
    function ieVersion() {
      var ua = window.navigator.userAgent;
      if (ua.indexOf("Trident/7.0") > -1)
        return 'MSIE 11.0';
      else if (ua.indexOf("Trident/6.0") > -1)
        return 'MSIE 10.0';
      else if (ua.indexOf("Trident/5.0") > -1)
        return 'MSIE 9.0';
      else
        return navigator.userAgent;  // not IE9, 10 or 11
    }


    doc.setAttribute('data-useragent', ieVersion() );

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js